import { STATEMENT_ACTIONS } from "constants/actions";

export function createStatement(caseId, bankAccountId, options) {
    return {
        type: STATEMENT_ACTIONS.CREATE_STATEMENT,
        payload: {
            caseId,
            bankAccountId,
            options
        }
    };
}

export function createdStatement(caseId, bankAccountId) {
    return {
        type: STATEMENT_ACTIONS.CREATED_STATEMENT,
        payload: {
            caseId,
            bankAccountId
        }
    };
}

export function deleteStatement(caseId, bankAccountId) {
    return {
        type: STATEMENT_ACTIONS.DELETE_STATEMENT,
        payload: { caseId, bankAccountId }
    };
}

export function deletedStatement(caseId, bankAccountId) {
    return {
        type: STATEMENT_ACTIONS.DELETED_STATEMENT,
        payload: {
            caseId,
            bankAccountId
        }
    };
}

export function failedDeleteStatement(error) {
    return {
        type: STATEMENT_ACTIONS.FAILED_DELETE_STATEMENT,
        payload: {
            error
        }
    };
}

export function fetchStatement(caseId, bankAccountId) {
    return {
        type: STATEMENT_ACTIONS.FETCH_STATEMENT,
        payload: {
            caseId,
            bankAccountId
        }
    };
}

export function fetchedStatement(caseId, bankAccountId, statement) {
    return {
        type: STATEMENT_ACTIONS.FETCHED_STATEMENT,
        payload: {
            caseId,
            bankAccountId,
            statement
        }
    };
}

export function failedFetchStatement(caseId, bankAccountId, error) {
    return {
        type: STATEMENT_ACTIONS.FAILED_FETCH_STATEMENT,
        payload: {
            caseId,
            bankAccountId
        },
        error
    };
}
export function updateStatement(caseId, bankAccountId, statement) {
    return {
        type: STATEMENT_ACTIONS.UPDATE_STATEMENT,
        payload: {
            caseId,
            bankAccountId,
            statement
        }
    };
}

export function updatedStatement(caseId, bankAccountId, statement) {
    return {
        type: STATEMENT_ACTIONS.UPDATED_STATEMENT,
        payload: {
            caseId,
            bankAccountId,
            statement
        }
    };
}

export function failedUpdateStatement(caseId, bankAccountId, error) {
    return {
        type: STATEMENT_ACTIONS.FAILED_UPDATE_STATEMENT,
        payload: {
            caseId,
            bankAccountId
        },
        error
    };
}
